import { combineReducers } from 'redux';

import loadTemplateConfigPreparationError from './loadTemplateConfigPreparationError';
import setFileError from './setFileError';
import resetFileError from './resetFileError';


export default combineReducers({
  loadTemplateConfigPreparationError,
  setFileError,
  resetFileError,
});
